import $ from 'jquery';

const W = window;

$.sendEvent = ({ name, value }) => {
  console.groupCollapsed('🗓 EVENT');
  console.log('NAME', name);
  console.log('VALUE', value);
  console.groupEnd();

  if (!Array.isArray(value)) value = [value];

  value.forEach(val => {
    if (W.gtag?.use_events) W.gtag('event', name, val);
    if (W.fbq?.use_events) W.fbq('trackCustom', name, val);
  });
};
